module.exports = __webpack_public_path__ + "img/play.b6ad16ad.png";